<template>
    <div :class="'parent-item-' + level">
        <div class="columns parent-row">
            <div
                class="column is-6">
                <span :style="{'margin-left':`${level * 20}px`}">
                    {{ parent.name }}
                </span>
            </div>
            <div class="column is-2" >
                <b-button @click="selectParent()"
                    :disabled="isCurrent"
                    :type="buttonType"
                    icon-right="clipboard-check">{{ $t ("choose") }}</b-button>
            </div>
        </div>
        <parent-tree v-for="p in parent.children" :key="p.id"
            :parent="p"
            :level="level + 1"
            :current="current"
        >
        </parent-tree>
    </div>
</template>

<script>
import { mapGetters, mapActions }   from 'vuex'

export default {
    name: "ParentTree",
    props: ["parent", "level", "current"],
    computed: { ...mapGetters(["getCompany"]),
    isCurrent () { return this.current == this.parent.id},
    buttonType () { return this.isCurrent ? 'is-link' : 'is-success'}
    },
    methods: {
        ...mapActions (["setNewParent"]),
        selectParent () {
            this.setNewParent ({
                self: this, parent: this.parent.id, company: this.getCompany})
        }
    }
}
</script>

<style scoped>
    .parent-row {
        border-bottom:  1px dotted black;
        margin:         0px;
    }
</style>